import ContractGroupDataTable from './contract-group-datatable.component.vue';
import ContractGroup from './contract-group.view.vue';

export default [
  {
    path: '/contract-group',
    component: ContractGroup,
    children: [
      {
        path: '/contract-group',
        name: 'ContractGroupDataTable',
        component: ContractGroupDataTable,
      },
    ],
  },
];
